// to parse strings like
// 1906MOWAMS1309AMSVIE0401VIELED
// 1906MOWAMS3006
const routeParseRegExp = /(\d{4})(?:([а-яА-Я\w]{3})([а-яА-Я\w]{3}))?/g;

export default function parseRoute(routeString) {
  const directions = [];

  let routePart;

  // eslint-disable-next-line no-cond-assign
  while ((routePart = routeParseRegExp.exec(routeString))) {
    // eslint-disable-next-line prefer-const
    let [, dateString, fromCode, toCode] = routePart;

    const day = Number(dateString.slice(0, 2));
    const month = Number(dateString.slice(2, 4));

    const now = new Date();
    const utcNow = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    let date = new Date(now.getFullYear(), month - 1, day);
    const yesterday = new Date(utcNow.getTime());
    yesterday.setDate(utcNow.getDate() - 1);

    if (date < yesterday) {
      // если дата в прошлом, значит поиск на следующий год
      // не <=, чтобы учесть возможность поиска в разных часовых поясах
      date = new Date(now.getFullYear() + 1, month - 1, day);
    }

    if (directions.length > 0) {
      const prevWay = directions[directions.length - 1];

      if (prevWay.date > date) {
        date.setFullYear(date.getFullYear() + 1);
      }

      // RT: 1906MOWAMS3006
      if (!toCode && !fromCode) {
        toCode = prevWay.fromCode;
        fromCode = prevWay.toCode;
      }
    }

    const direction = {
      date,
      fromCode,
      toCode,
    };

    directions.push(direction);
  }

  const isRT =
    directions.length === 2 &&
    directions[0].fromCode === directions[1].toCode &&
    directions[1].fromCode === directions[0].toCode;

  const isOW = directions.length === 1;
  const isMW = !isRT && !isOW;

  let fromCode = '';
  let toCode = '';
  let fromDate = '';
  let toDate = '';

  if (directions.length > 0) {
    fromCode = directions[0].fromCode;
    toCode = isRT ? directions[0].toCode : directions[directions.length - 1].toCode;

    fromDate = directions[0].date;
    toDate = directions[directions.length - 1].date;
  }

  const route = {
    routeString,
    isRT,
    isOW,
    isMW,
    directions,
    fromCode,
    toCode,
    fromDate,
    toDate,
  };

  return route;
}
